import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { HEALTH_VIEW_DATA } from "./HealthView.constants";

export const renderHeaderWithTooltip = (headerName: string | undefined, tooltipText: string) => {
  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          minWidth: 0,
          width: "100%",
          whiteSpace: "normal",
          overflowWrap: "normal",
          wordBreak: "normal",
          lineHeight: 1.2,
          cursor: "help"
        }}
      >
        <span style={{ flex: 1, minWidth: 0 }}>{headerName}</span>
        <InfoOutlinedIcon
          aria-label="More information"
          sx={{ fontSize: 14, color: "#605E5C", flexShrink: 0 }}
        />
      </span>
    </Tooltip>
  );
};

const getStatusFromScore = (score: number | null | undefined) => {
  if (score == null || Number.isNaN(score)) {
    return "Other";
  }

  if (score <= 40) {
    return "Critical";
  }

  if (score <= 70) {
    return "Warning";
  }

  return "Healthy";
};

const getBackgroundColorFromStatus = (status: string | undefined) => {
  if (status === "Healthy") {
    return HEALTH_VIEW_DATA.STATUS_COLOURS.Healthy;
  }

  if (status === "Warning") {
    return HEALTH_VIEW_DATA.STATUS_COLOURS.Warning;
  }

  if (status === "Critical") {
    return HEALTH_VIEW_DATA.STATUS_COLOURS.Critical;
  }

  return HEALTH_VIEW_DATA.STATUS_COLOURS.Other;
};

export const renderScoreCell = (score: number | null | undefined, status?: string) => {
  const resolvedStatus = status ?? getStatusFromScore(score);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        backgroundColor: getBackgroundColorFromStatus(resolvedStatus),
        color: "white",
        fontWeight: "bold"
      }}
    >
      {score == null ? "NA" : score}
    </div>
  );
};